<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="省份：">
                        <el-select v-model="sf_id" placeholder="请选择" size="small" @change="getsq">
                            <el-option v-for="item in sf_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="城市：">
                        <el-select v-model="sq_id" placeholder="请选择" size="small" clearable @change="getqy">
                            <el-option v-for="item in sq_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区域：">
                        <el-select v-model="qy_id" placeholder="请选择" size="small" clearable @change="getjd">
                            <el-option v-for="item in qy_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模糊搜索：">
                        <el-input placeholder="请输入查询区域" size="small" @blur="search" v-model="title"
                            class="heade_ipt" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" @click="search" icon="el-icon-search" type="primary">搜索
                        </el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button size="small" @click="add('form')" icon="el-icon-circle-plus-outline"
                            type="primary">新增</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
             <el-table :data="tableData" v-loading="loading" border :height="heights">
                    <el-table-column prop="code" label="ID" width="120"></el-table-column>
                    <el-table-column prop="name" :label="area_head"></el-table-column>
                    <el-table-column label="操作" width="280">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="handleAdd(scope.$index, scope.row)"
                                v-if="scope.row.CityRemark != 'town'">
                                {{addbtn}}
                            </el-button>
                            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)"
                                v-if="scope.row.edit == '1'">
                                编辑
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
                                v-if="scope.row.edit == '1'">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </div>
        <!--  -->
        <el-dialog title="新增" :visible.sync="dialogadd" top="80px" width="45%"  class="dialogs">
            <el-divider></el-divider>
            <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm"
                style="margin: 20px;">
                <el-form-item label="上级地区:">
                    <span>{{form.area_name}}</span>
                </el-form-item>
                <el-form-item :label="area_name" prop="CityName">
                    <el-input size="small" v-model="form.CityName" ></el-input>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addsubmit('form')" size="small">确 定</el-button>
                <el-button @click="dialogadd = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 编辑 -->
        <el-dialog title="编辑" :visible.sync="dialog_edit" top="80px" width="45%" class="dialogs">
            <el-divider></el-divider>
            <el-form ref="forms" :model="forms" label-width="140px" :rules="rules" class="demo-ruleForm"
                style="margin: 20px;">
                <el-form-item label="上级地区:">
                    <span>{{forms.area_name}}</span>
                </el-form-item>
                <el-form-item :label="area_names" prop="CityName">
                    <el-input size="small" v-model="forms.CityName" ></el-input>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editsubmit('forms')" size="small">确 定</el-button>
                <el-button @click="dialog_edit = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
               
                heights:null,
                tableData: [],
                sf_id: '',
                sq_id: '',
                qy_id: '',
                sf_options: [],
                sq_options: [],
                qy_options: [],
                title: '',
                area_head: '城市',
                area_name: '',
                area_names: '',
                addbtn: '',
                search_id: '',
                loading: false,
                dialogadd: false,
                dialog_edit: false,
                sf_option: [],
                sq_option: [],
                qy_option: [],
                form: {
                    area_name: '',
                    CityName: '',
                    CityRemark: '',
                    ParentCode: ''
                },
                rule: {
                    CityName: [{
                        required: true,
                        message: '地区名称不能为空',
                        trigger: 'blur'
                    }]
                },
                forms: {
                    area_name: '',
                    CityName: '',
                    CityRemark: '',
                    ParentCode: '',
                    CityCode: ''
                },
                rules: {
                    CityName: [{
                        required: true,
                        message: '地区名称不能为空',
                        trigger: 'blur'
                    }]
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
             this.all_sheng()
        },
        methods: {
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 135 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 135 + 'px'
                }
            },
            search() {
                let that = this
                that.currentPage4 = 1
                if (that.sf_id == '') {
                    that.$alert("请选择省份！！")
                } else {
                    axios
                        .post("/admin/Area/getChild_vue", {
                            parentcode: that.search_id,
                            check: that.title,
                        },{
                        token:true
                    })
                        .then(response => {
                            that.tableData = response.data.data
                            if (that.sq_id != '') {
                                that.addbtn = '新增街道'
                                that.area_head = '区域'
                            } else {
                                that.addbtn = '新增区域'
                                that.area_head = '城市'
                            }
                            if (that.qy_id != '') {
                                that.area_head = '街道'
                            }
                        })
                        .catch(error => {})
                }
            },
            all_sheng() {
                let that = this
                axios 
                    .post("/admin/Area/getProvince_vue", {
                    },{
                        token:true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                        that.sf_option = response.data.data
                        that.addbtn = '新增城市'
                        that.sf_id = '320000'
                        that.search_id = that.sf_id
                        that.getsq()
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.search_id = that.sf_id
                that.sq_options = []
                that.sq_id = ''
                that.qy_options = []
                that.qy_id = ''
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.sf_id,
                    },{
                        token:true
                    })
                    .then(response => {
                        that.sq_options = response.data.data
                        that.search()
                    })
                    .catch(error => {})
            },
            getqy() {
                let that = this
                if (that.sq_id == '') {
                    that.search_id = that.sf_id
                } else {
                    that.search_id = that.sq_id
                    axios
                        .post("/admin/Area/getChild_vue", {
                            parentcode: that.sq_id,
                        },{
                        token:true
                    })
                        .then(response => {
                            that.qy_options = response.data.data
                            that.search()
                        })
                        .catch(error => {})
                }
                that.qy_options = []
                that.qy_id = ''
            },
            getjd() {
                let that = this
                if (that.qy_id == '') {
                    that.search_id = that.sq_id
                } else {
                    that.search_id = that.qy_id
                }
                that.search()
            },
            add(formName) {
                if (this.sf_id == '') {
                    this.$alert("请选择省份！！")
                } else {
                    if (this.qy_id != '') {
                        this.form.ParentCode = this.qy_id
                        this.form.CityRemark = 'town'
                        this.area_name = '新增街道名称：'
                        this.qy_options.forEach(item => {
                            if (item.code == this.qy_id) {
                                this.form.area_name = item.name
                            }
                        });
                    } else if (this.sq_id != '') {
                        this.form.ParentCode = this.sq_id
                        this.form.CityRemark = 'area'
                        this.area_name = '新增区域名称：'
                        this.sq_options.forEach(item => {
                            if (item.code == this.sq_id) {
                                this.form.area_name = item.name
                            }
                        });
                    } else {
                        this.form.ParentCode = this.sf_id
                        this.form.CityRemark = 'city'
                        this.area_name = '新增城市名称：'
                        this.sf_options.forEach(item => {
                            if (item.code == this.sf_id) {
                                this.form.area_name = item.name
                            }
                        });
                    }
                    this.dialogadd = true
                }
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            handleAdd(index, row) {
                this.form.area_name = row.name
                this.form.ParentCode = row.code
                if (row.CityRemark == 'city') {
                    this.form.CityRemark = 'area'
                    this.area_name = '新增区域名称：'
                }
                if (row.CityRemark == 'area') {
                    this.form.CityRemark = 'town'
                    this.area_name = '新增街道名称：'
                }
                this.dialogadd = true
            },
            addsubmit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/Area/cityEdit", {
                                CityName: that.form.CityName,
                                CityRemark: that.form.CityRemark,
                                ParentCode: that.form.ParentCode,
                            },{
                        token:true
                    })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogadd = false
                                    that.$refs[formName].resetFields();
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: '添加成功'
                                    });
                                    that.search()
                                } else {
                                    that.$alert(response.data.msg)
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                    }
                })
            },
            handleEdit(index, row) {
                if (row.CityRemark == 'city') {
                    this.area_names = '编辑城市名称：'
                    this.forms.ParentCode = this.sf_id
                    this.sf_options.forEach(item => {
                        if (this.sf_id == item.code) {
                            this.forms.area_name = item.name
                        }
                    });
                }
                if (row.CityRemark == 'area') {
                    this.area_names = '编辑区域名称：'
                    this.forms.ParentCode = this.sq_id
                    this.sq_options.forEach(item => {
                        if (this.sq_id == item.code) {
                            this.forms.area_name = item.name
                        }
                    });
                }
                if (row.CityRemark == 'town') {
                    this.area_names = '编辑街道名称：'
                    this.forms.ParentCode = this.qy_id
                    this.qy_options.forEach(item => {
                        if (this.qy_id == item.code) {
                            this.forms.area_name = item.name
                        }
                    });
                }
                this.forms.CityRemark = row.CityRemark
                this.forms.CityName = row.name
                this.forms.CityCode = row.code
                this.dialog_edit = true
            },
            editsubmit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/Area/cityEdit", {
                                CityName: that.forms.CityName,
                                CityRemark: that.forms.CityRemark,
                                ParentCode: that.forms.ParentCode,
                                CityCode: that.forms.CityCode,
                            },{
                        token:true
                    })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialog_edit = false
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: '编辑成功'
                                    });
                                    that.search()
                                } else {
                                    that.$alert(response.data.msg)
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                    }
                })
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm("确认删除？")
                    .then(_ => {
                        axios
                            .post("/admin/Area/cityDel", {
                                CityCode: row.code,
                            },{
                        token:true
                    })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.search()
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: '删除成功'
                                    });
                                } else {
                                    that.$alert(response.data.msg)
                                }
                            })
                            .catch(error => {})
                    })
                    .catch(_ => {});
            },
            handleSizeChange(val) {
                this.pagesize = val
            },
            handleCurrentChange(val) {
                this.currentPage4 = val
            },
        },
          watch: {
            title() {
                this.search()
            }
        },

    };
</script>